/* Turf Care Pro — trade-ready basket behaviour (5-10-2026).
   Every change goes to Shopify's cart API and the section is re-rendered by the Section Rendering API,
   so prices, totals and rules always come from Liquid. Delegated listeners survive re-renders. */
(function () {
  'use strict';
  var host = document.querySelector('[data-tct]');
  if (!host) return;
  var sid = host.getAttribute('data-section');
  var JSONH = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var undoData = null, undoTimer = null, qtyTimers = {}, saveTimer = null, busy = false;

  function root() { return host.querySelector('[data-tct-root]'); }
  function fire() { ['cart:refresh', 'cart:update', 'cart-update'].forEach(function (e) { document.dispatchEvent(new CustomEvent(e, { bubbles: true })); }); }

  function swap(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nr = doc.querySelector('[data-tct-root]');
    if (!nr) return;
    var act = document.activeElement, key = null, sel = null;
    if (act && host.contains(act)) {
      var li = act.closest('[data-key]');
      key = li && li.getAttribute('data-key');
      sel = act.hasAttribute('data-tct-qty') ? '[data-tct-qty]' : act.hasAttribute('data-tct-step') ? '[data-tct-step="' + act.getAttribute('data-tct-step') + '"]' : null;
    }
    root().innerHTML = nr.innerHTML;
    var od = host.querySelector('[data-tct-dlg]'), nd = doc.querySelector('[data-tct-dlg]');
    if (od && !od.open) { if (nd) od.replaceWith(nd); else od.remove(); }
    else if (!od && nd) host.appendChild(nd);
    if (key && sel) { var t = root().querySelector('[data-key="' + key + '"] ' + sel); if (t) t.focus(); }
    initBar(); recent();
  }
  function rerender() {
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(sid) + '&_=' + Date.now(), { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); }).then(function (j) { swap(j[sid]); });
  }
  function post(url, body) {
    body.sections = sid; body.sections_url = window.location.pathname;
    return fetch(url, { method: 'POST', headers: JSONH, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong'); return j; }); });
  }

  /* ---------- quantity ---------- */
  function setQty(li, q, isRemove) {
    var key = li.getAttribute('data-key');
    if (isRemove) {
      undoData = { id: +li.getAttribute('data-vid'), quantity: +li.getAttribute('data-qty'), title: li.getAttribute('data-title') };
      try { var pr = JSON.parse(li.getAttribute('data-props') || 'null'); if (pr && Object.keys(pr).length) undoData.properties = pr; } catch (e) {}
    }
    li.classList.add('is-busy');
    post('/cart/change.js', { id: key, quantity: q })
      .then(function (j) {
        swap(j.sections && j.sections[sid]); fire();
        if (isRemove) showUndo();
        else { var it = (j.items || []).filter(function (x) { return x.key === key; })[0]; if (it && it.quantity < q) toast('Only ' + it.quantity + ' available for this item.'); }
      })
      .catch(function (e) { li.classList.remove('is-busy'); toast(e.message); rerender(); });
  }
  host.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tct-step]');
    if (b) {
      var li = b.closest('[data-key]'), inp = li.querySelector('[data-tct-qty]');
      var q = Math.max(0, (parseInt(inp.value, 10) || 0) + +b.getAttribute('data-tct-step'));
      inp.value = q;
      clearTimeout(qtyTimers[li.getAttribute('data-key')]);
      qtyTimers[li.getAttribute('data-key')] = setTimeout(function () { setQty(li, q, q === 0); }, 350);
      return;
    }
    var rm = e.target.closest('[data-tct-rm]');
    if (rm) { setQty(rm.closest('[data-key]'), 0, true); return; }
    var add = e.target.closest('[data-tct-add]');
    if (add) {
      add.disabled = true; add.textContent = 'Adding…';
      post('/cart/add.js', { items: [{ id: +add.getAttribute('data-tct-add'), quantity: 1 }] })
        .then(function (j) { fire(); if (j.sections && j.sections[sid]) swap(j.sections[sid]); else return rerender(); })
        .catch(function (er) { add.disabled = false; add.textContent = 'Add to basket'; toast(er.message); });
      return;
    }
    var cp = e.target.closest('[data-tct-copy]');
    if (cp) { copy(cp); return; }
    if (e.target.closest('[data-tct-quote]')) { openDlg(); return; }
    if (e.target.closest('[data-tct-dlgclose]')) { var d = host.querySelector('[data-tct-dlg]'); if (d) d.close(); return; }
    if (e.target.closest('[data-tct-barbtn]')) { var c = root().querySelector('[data-tct-checkout]'); if (c) c.click(); return; }
    if (e.target.closest('[data-tct-undo-b]')) { doUndo(); }
  });
  host.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-tct-qty]');
    if (inp) { var q = Math.max(0, parseInt(inp.value, 10) || 0); setQty(inp.closest('[data-key]'), q, q === 0); return; }
    var cert = e.target.closest('[data-tct-cert]');
    if (cert) {
      cert.disabled = true;
      post('/cart/update.js', { attributes: { 'Professional use confirmed': cert.checked ? 'Yes' : '' } })
        .then(function (j) { swap(j.sections && j.sections[sid]); })
        .catch(function (er) { cert.disabled = false; toast(er.message); });
    }
  });
  host.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-tct-qty]')) { e.preventDefault(); e.target.blur(); }
  });

  /* ---------- checkout guard ---------- */
  host.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches('[data-tct-form]')) return;
    var btn = f.querySelector('[data-tct-checkout]');
    if (btn && btn.getAttribute('aria-disabled') === 'true') {
      e.preventDefault();
      var why = f.querySelector('[data-tct-why]'); if (why) why.hidden = false;
      var cert = f.querySelector('[data-tct-cert]');
      if (cert && !cert.checked) { cert.scrollIntoView({ behavior: 'smooth', block: 'center' }); cert.focus(); }
      else { var g = f.querySelector('.is-gone'); if (g) g.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    }
  });

  /* ---------- organisation / PO / note autosave ---------- */
  host.addEventListener('input', function (e) {
    if (!e.target.matches('[data-tct-save]')) return;
    var s = root().querySelector('[data-tct-saved]');
    if (s) { s.classList.remove('is-saved'); s.textContent = 'Saving…'; }
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      var f = root().querySelector('[data-tct-form]'), attrs = {}, note = '';
      f.querySelectorAll('[data-tct-save]').forEach(function (el) {
        if (el.name === 'note') note = el.value;
        else { var m = el.name.match(/^attributes\[(.+)\]$/); if (m) attrs[m[1]] = el.value; }
      });
      fetch('/cart/update.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ attributes: attrs, note: note }) })
        .then(function (r) { if (!r.ok) throw 0; var s2 = root().querySelector('[data-tct-saved]'); if (s2) { s2.textContent = 'Saved — these go through to checkout and appear on your order.'; s2.classList.add('is-saved'); } })
        .catch(function () { var s3 = root().querySelector('[data-tct-saved]'); if (s3) s3.textContent = 'Could not save just now. They will still be sent when you check out.'; });
    }, 600);
  });

  /* ---------- undo + toast ---------- */
  function toastEl() { return host.querySelector('[data-tct-undo]'); }
  function showUndo() {
    var t = toastEl(); if (!t || !undoData) return;
    t.querySelector('[data-tct-undo-t]').textContent = 'Removed ' + undoData.title;
    t.querySelector('[data-tct-undo-b]').hidden = false; t.hidden = false;
    clearTimeout(undoTimer); undoTimer = setTimeout(function () { t.hidden = true; undoData = null; }, 8000);
  }
  function toast(msg) {
    var t = toastEl(); if (!t) return;
    t.querySelector('[data-tct-undo-t]').textContent = msg;
    t.querySelector('[data-tct-undo-b]').hidden = true; t.hidden = false;
    clearTimeout(undoTimer); undoTimer = setTimeout(function () { t.hidden = true; }, 5000);
  }
  function doUndo() {
    if (!undoData || busy) return;
    busy = true; var d = undoData; undoData = null; toastEl().hidden = true;
    var it = { id: d.id, quantity: d.quantity }; if (d.properties) it.properties = d.properties;
    post('/cart/add.js', { items: [it] }).then(function (j) { fire(); if (j.sections && j.sections[sid]) swap(j.sections[sid]); else return rerender(); })
      .catch(function (e) { toast(e.message); }).then(function () { busy = false; });
  }

  /* ---------- share link ---------- */
  function copy(b) {
    var url = b.getAttribute('data-url'), t = b.querySelector('[data-tct-copy-t]');
    function done(ok) { t.textContent = ok ? 'Link copied' : url; setTimeout(function () { t.textContent = 'Copy a link to this basket'; }, 3000); }
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(url).then(function () { done(true); }, function () { done(false); });
    else {
      var ta = document.createElement('textarea'); ta.value = url; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select(); var ok = false; try { ok = document.execCommand('copy'); } catch (e) {} ta.remove(); done(ok);
    }
  }

  /* ---------- quote dialog ---------- */
  function openDlg() {
    var d = host.querySelector('[data-tct-dlg]'); if (!d) return;
    var src = root().querySelector('input[name="attributes[Organisation]"]'), dst = d.querySelector('input[name="contact[Organisation]"]');
    if (src && dst && src.value && !dst.value) dst.value = src.value;
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
    var f = d.querySelector('input[type="text"], input[type="email"]'); if (f) f.focus();
  }
  host.addEventListener('click', function (e) { var d = e.target; if (d.matches && d.matches('[data-tct-dlg]')) d.close(); });
  if (/[?&]contact_posted=true/.test(location.search) || /#tct-quote-form|#contact_form/.test(location.hash)) {
    var dq = host.querySelector('[data-tct-dlg]');
    if (dq && dq.querySelector('.tct-qf__ok, .tct-qf__err')) openDlg();
  }

  /* ---------- mobile checkout bar: shows only while the summary button is off screen ---------- */
  var io = null;
  function initBar() {
    var bar = root().querySelector('[data-tct-bar]'), btn = root().querySelector('[data-tct-checkout]');
    if (io) { io.disconnect(); io = null; }
    if (!bar || !btn || !('IntersectionObserver' in window)) return;
    io = new IntersectionObserver(function (en) {
      var vis = en[0].isIntersecting, below = en[0].boundingClientRect.top > 0;
      bar.classList.toggle('is-on', !vis && below);
    });
    io.observe(btn);
  }

  /* ---------- recently viewed (empty basket only) ---------- */
  function money(c) { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(c / 100); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function recent() {
    var box = root().querySelector('[data-tct-recent]'); if (!box) return;
    var list = []; try { list = JSON.parse(localStorage.getItem('tcpRecent') || '[]'); } catch (e) {}
    list = (Array.isArray(list) ? list : []).slice(0, 4);
    if (!list.length) return;
    Promise.all(list.map(function (h) { return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
      .then(function (ps) {
        var html = ps.filter(Boolean).map(function (p) {
          var img = p.featured_image ? '<img src="' + esc(p.featured_image) + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=360" alt="" loading="lazy" width="180" height="135">' : '';
          return '<li class="tct-sc"><a class="tct-sc__img" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a><div class="tct-sc__b">' +
            '<a class="tct-sc__t" href="' + esc(p.url) + '">' + esc(String(p.title).split(' - ')[0]) + '</a>' +
            '<span class="tct-sc__p">' + (p.price_varies ? 'From ' : '') + money(p.price_min) + '</span>' +
            '<a class="tct-btn tct-btn--line" href="' + esc(p.url) + '">View product</a></div></li>';
        }).join('');
        if (!html) return;
        box.querySelector('[data-tct-recent-list]').innerHTML = html; box.hidden = false;
      });
  }

  initBar(); recent();
})();
